<template>
  <div id="app-MD">
    <div class="contentWrapper">
      <div class="activeComponent">
        <!-- <keep-alive>
          <component :is="active" :key="active"></component>
        </keep-alive> -->
        <component :is="active" :key="active"></component>
      </div>
      <div class="footer">
        <van-tabbar v-model="active" active-color="#00c688" @change="onChange">
          <van-tabbar-item name="serve" icon="location-o">
            <span>服务</span>
            <van-icon
              class="iconfont"
              class-prefix="icon"
              slot="icon"
              slot-scope="props"
              :name="props.active ? icon.serve : icon.serve"
            />
            <!-- <template #icon="props">
              <img :src="props.active ? icon.shopping : icon.shopping" />
            </template> -->
          </van-tabbar-item>
          <van-tabbar-item name="liveStreaming" icon="other-pay">
            <span>直播</span>
            <van-icon
              class="iconfont"
              class-prefix="icon"
              slot="icon"
              slot-scope="props"
              :name="props.active ? icon.liveStreaming : icon.liveStreaming"
            />
          </van-tabbar-item>
          <van-tabbar-item name="home">
            <span>我的</span>
            <van-icon
              class="iconfont"
              class-prefix="icon"
              slot="icon"
              slot-scope="props"
              :name="props.active ? icon.home : icon.home"
            />
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
  </div>
</template>

<script>
import home from "./home.vue";
import liveStreaming from "./liveStreaming.vue";
import serve from "./serve.vue";
import "@/assets/gzh/iconFont/iconfont.css";
export default {
  name: "MD",
  components: {
    home,
    liveStreaming,
    serve
  },
  data() {
    return {
      active: "serve",
      icon: {
        home: "shouye1",
        liveStreaming: "video",
        // shopping: require('@/assets/gzh/serve2.png'),
        serve: "ReadingModeMobile",
        service: "customer-service"
      }
    };
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem('active'))) {
      this.active=JSON.parse(sessionStorage.getItem('active'))
    }
  },
  methods: {
    // 切换
    onChange() {
      sessionStorage.setItem('active',JSON.stringify(this.active))
    }
  },

};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-MD {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-MD {
    width: 276px * $zoom;
  }
}
#app-MD {
  font-size: 16px * $zoom;
  height: 100%;
  .contentWrapper {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .activeComponent {
      flex: 1;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    @media screen and (max-width: 600px) {
      .footer {
        width: 100%;
      }
    }
    @media screen and (min-width: 600px) {
      .footer {
        width: 276px * $zoom;
      }
    }
    .footer {
      position: relative;
      height: 92px;
      ::v-deep .van-tabbar--fixed {
        position: absolute;
        width: 100%;
      }
      ::v-deep .icon-shouye1:before {
        font-size: 40px;
      }
      ::v-deep .icon-video:before {
        font-size: 40px;
      }
      ::v-deep .icon-ReadingModeMobile:before {
        font-size: 40px;
      }
      ::v-deep .icon-customer-service:before {
        font-size: 40px;
      }
    }
  }
}
</style>
